/* import __COLOCATED_TEMPLATE__ from './group.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();